import React, { PureComponent } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import { withStyles } from '@material-ui/core';
import { FHETable } from 'data/components';
import tools from 'data/common/tools';

class ListingBoxes extends PureComponent {
    static propTypes = {
        Boxes: PropTypes.object.isRequired,
        env: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        classes: PropTypes.object.isRequired
    };

    renderColumns = memoizeOne(() => {
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'boxMac'
            },
            {
                title: Translator.translate('general.table.column.homeId'),
                name: 'homeId'
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            },
            {
                title: Translator.translate('general.table.column.provisionedDate'),
                name: 'provisionedDate',
                defaultSort: 'asc'
            }
        ];
    });

    renderData = memoizeOne(Boxes => {
        let result = [];

        Boxes.map(Boxe => {
            result.push({
                boxMac: Boxe.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                homeId: Boxe.get('homeId'),
                firmwareVersion: Boxe.get('firmwareVersion'),
                provisionedDate: Boxe.get('provisionedDate')
            });
        });
        return result;
    });

    render() {
        const { Boxes, loading, env } = this.props;
        return <FHETable idTable={`BoxesList${env}`} columns={this.renderColumns()} data={this.renderData(Boxes)} minified isLoading={loading} />;
    }
}

const styles = theme => ({
    title: {
        color: theme.palette.primary.main
    },
    warning: {
        color: theme.palette.warning.main,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: 40,
        lineHeight: 'normal',
        marginBottom: 60,
        textAlign: 'center'
    }
});

export default withStyles(styles, { withTheme: true })(ListingBoxes);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/components/ListingBoxes.js